import React from 'react';

const ScopeBoundary = ({ delivers, doesNotDeliver }) => (
  <div style={{ margin: '24px 0' }}>
    <div style={{
      background: '#F0FDF4',
      border: '1px solid #BBF7D0',
      borderRadius: '10px',
      padding: '16px',
      marginBottom: '12px'
    }}>
      <p style={{
        fontSize: '11px', fontWeight: 700, color: '#15803D',
        textTransform: 'uppercase', letterSpacing: '0.08em',
        margin: '0 0 8px 0'
      }}>
        What this gives you
      </p>
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        {delivers.map((item, i) => (
          <li key={i} style={{ fontSize: '14px', color: '#111827', marginBottom: '4px' }}>
            {item}
          </li>
        ))}
      </ul>
    </div>
    <div style={{
      background: '#F8FAFC',
      border: '1px solid #E2E8F0',
      borderRadius: '10px',
      padding: '16px',
      marginBottom: '24px'
    }}>
      <p style={{
        fontSize: '11px', fontWeight: 700, color: '#64748B',
        textTransform: 'uppercase', letterSpacing: '0.08em',
        margin: '0 0 8px 0'
      }}>
        What it does not include
      </p>
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        {doesNotDeliver.map((item, i) => (
          <li key={i} style={{ fontSize: '14px', color: '#64748B', marginBottom: '4px' }}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default ScopeBoundary;
